export default "__VITE_ASSET__DEW4lhjM__"